import React from 'react';
import { Button, ButtonProps } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';

export type ButtonLinkProps = Exclude<ButtonProps, 'onClick'> & {
  href: string;
};

export const ButtonLink: React.FC<ButtonLinkProps> = (props) => {
  const navigate = useNavigate();
  return (
    <Button
      {...props}
      onClick={(event) => {
        if (props.target !== '_blank') {
          event.preventDefault();
          navigate(props.href);
        }
      }}
    >
      {props.children}
    </Button>
  );
};
